import React from 'react'
import PropTypes from 'prop-types'
import withPolyglot from '../withPolyglot'

const SelectionList = ({options = [], removeElement, withEdit, innerField, isInputInFocus, focusInput, translate}) => {
  return <div className='uk-clearfix'>
    {options.length > 0
      ? <div className=''>
        {options.map((option, i) => (
          <ul className={'uk-clearfix selection-list uk-list uk-margin-small-left'} key={i}>
            <li className='uk-float-left'>{option.displayValue}</li>
            {removeElement
              ? <span
                className='uk-flex-middle uk-float-right list-close-icon icon-button'
                data-uk-icon='close'
                onClick={() => removeElement(option.value)} />
              : null
            }
          </ul>
        ))}
      </div>
      : null
    }
    <div data-uk-grid>
      {isInputInFocus
        ? <div className='uk-width-expand'>{innerField}</div>
        : options.length > 0 ? <div className='uk-width-expand' /> : <div className={'selection-list uk-width-expand'}>
          <div><span onClick={focusInput} className='placeholder'>{translate('noElements')}</span></div>
        </div>
      }
      {withEdit
        ? <span
          className='uk-flex-middle uk-width-auto uk-margin-small uk-float-right list-add-icon icon-button'
          data-uk-icon='plus'
          onClick={focusInput} />
        : null
      }
    </div>

  </div>
}

SelectionList.propTypes = {
  isInputInFocus: PropTypes.bool.isRequired,
  focusInput: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  removeElement: PropTypes.func.isRequired,
  withEdit: PropTypes.bool.isRequired
}

SelectionList.defaultProps = {
  isInputInFocus: false
}

export default withPolyglot(SelectionList, 'selectionList')
